import { render, staticRenderFns } from "./CrudWorkDetails.vue?vue&type=template&id=9cfc6a66&scoped=true"
import script from "./CrudWorkDetails.vue?vue&type=script&lang=ts"
export * from "./CrudWorkDetails.vue?vue&type=script&lang=ts"
import style0 from "./CrudWorkDetails.vue?vue&type=style&index=0&id=9cfc6a66&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cfc6a66",
  null
  
)

export default component.exports